import type { ORG_ROUTES } from '@/config/router';

type OrgRoutes = ReturnType<typeof ORG_ROUTES>;

// processors.type is free text: prod holds rows whose type has no edit page (platformpay, whop, ...).
export const getProcessorEditRoute = (
  orgRoutes: OrgRoutes,
  type: string,
  processorId: string,
): string | null => {
  switch (type) {
    case 'stripe':
      return orgRoutes.PROCESSOR_EDIT_STRIPE(processorId);
    case 'nmi':
      return orgRoutes.PROCESSOR_EDIT_NMI(processorId);
    case 'onyx':
      return orgRoutes.PROCESSOR_EDIT_ONYX(processorId);
    case 'routesense':
      return orgRoutes.PROCESSOR_EDIT_ROUTESENSE(processorId);
    case 'finix':
      return orgRoutes.PROCESSOR_EDIT_FINIX(processorId);
    case 'mastercard':
      return orgRoutes.PROCESSOR_EDIT_MASTERCARD(processorId);
    case 'airwallex':
      return orgRoutes.PROCESSOR_EDIT_AIRWALLEX(processorId);
    case 'checkout':
      return orgRoutes.PROCESSOR_EDIT_CHECKOUT(processorId);
    case 'tagadapay':
      return orgRoutes.PROCESSOR_EDIT_TAGADAPAY(processorId);
    case 'tagadapay-router':
      return orgRoutes.PROCESSOR_EDIT_TAGADAPAY_ROUTER(processorId);
    case 'efipayments':
      return orgRoutes.PROCESSOR_EDIT_EFIPAYMENTS(processorId);
    case 'merchantscale':
      return orgRoutes.PROCESSOR_EDIT_MERCHANTSCALE(processorId);
    case 'bakolapay':
      return orgRoutes.PROCESSOR_EDIT_BAKOLAPAY(processorId);
    case 'sandbox':
      return orgRoutes.PROCESSOR_EDIT_SANDBOX(processorId);
    case 'trustflow':
      return orgRoutes.PROCESSOR_EDIT_TRUSTFLOW(processorId);
    case 'kesspay':
      return orgRoutes.PROCESSOR_EDIT_KESSPAY(processorId);
    case 'ovri':
      return orgRoutes.PROCESSOR_EDIT_OVRI(processorId);
    case 'ccavenue':
      return orgRoutes.PROCESSOR_EDIT_CCAVENUE(processorId);
    case 'ngenius':
      return orgRoutes.PROCESSOR_EDIT_NGENIUS(processorId);
    case 'tap':
      return orgRoutes.PROCESSOR_EDIT_TAP(processorId);
    case 'authorizenet':
      return orgRoutes.PROCESSOR_EDIT_AUTHORIZENET(processorId);
    case 'convesio':
      return orgRoutes.PROCESSOR_EDIT_CONVESIO(processorId);
    case 'adyen':
      return orgRoutes.PROCESSOR_EDIT_ADYEN(processorId);
    case 'payland':
      return orgRoutes.PROCESSOR_EDIT_PAYLAND(processorId);
    case 'paysafe':
      return orgRoutes.PROCESSOR_EDIT_PAYSAFE(processorId);
    case 'bluesnap':
      return orgRoutes.PROCESSOR_EDIT_BLUESNAP(processorId);
    case 'worldpay':
      return orgRoutes.PROCESSOR_EDIT_WORLDPAY(processorId);
    case 'braintree':
      return orgRoutes.PROCESSOR_EDIT_BRAINTREE(processorId);
    case 'mollie':
      return orgRoutes.PROCESSOR_EDIT_MOLLIE(processorId);
    case 'fiserv':
      return orgRoutes.PROCESSOR_EDIT_FISERV(processorId);
    case 'paystack':
      return orgRoutes.PROCESSOR_EDIT_PAYSTACK(processorId);
    case 'payu':
      return orgRoutes.PROCESSOR_EDIT_PAYU(processorId);
    case 'razorpay':
      return orgRoutes.PROCESSOR_EDIT_RAZORPAY(processorId);
    case 'payone':
      return orgRoutes.PROCESSOR_EDIT_PAYONE(processorId);
    case 'globalpay':
      return orgRoutes.PROCESSOR_EDIT_GLOBALPAY(processorId);
    case 'buzipay':
      return orgRoutes.PROCESSOR_EDIT_BUZIPAY(processorId);
    case 'netvalve':
      return orgRoutes.PROCESSOR_EDIT_NETVALVE(processorId);
    case 'xoala':
      return orgRoutes.PROCESSOR_EDIT_XOALA(processorId);
    case 'unlimit':
      return orgRoutes.PROCESSOR_EDIT_UNLIMIT(processorId);
    default:
      return null;
  }
};
